<template>
  <footer class="footer-section full-width-section">
    <div class="footer-container">
      <div class="footer-left">
        <p class="footer-slogan">{{ t('footer.slogan') }}</p>
      </div>
      <div class="footer-center">
          <img class="qr-code" src="/assets/qrcode.png" alt="二维码">
      </div>
      <div class="footer-right">
        <div class="footer-logo">
          <img src="/assets/fabet_logo.png" alt="Fabet公司logo">
        </div>
        <div class="footer-links">
          <a href="/">{{ t('footer.home') }}</a>
          <a href="/products">{{ t('footer.products') }}</a>
          <a href="/solution">{{ t('footer.solutions') }}</a>
          <a href="/tech-support">{{ t('footer.techSupport') }}</a> 
          <a href="/contact">{{ t('footer.contact') }}</a>
        </div>
        <div class="footer-contact">
          <p>{{ t('footer.phone') }}8621-64828578</p>
          <p>{{ t('footer.email') }}postmaster@fabetgroup.com</p>
        </div>
      </div>
    </div>
    <!-- 将版权信息移到这里，作为footer的直接子元素 -->
    <div class="copyright-container">
      <p class="footer-copyright">{{ t('footer.copyright') }}</p>
      <p class="footer-security">{{ t('footer.security') }}</p>
    </div>
  </footer>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'FooterComponent',
  setup() {
    const { t } = useI18n();
    return { t };
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/sections/homepage/footer_section"; // 引入全局样式


.footer-section {
  margin-top: 0 !important;
  padding: 20px 0;
  background-color: #f5f5f5;
  position: relative;
}

/* 新增的版权信息容器样式，使其居中显示 */
.copyright-container {
  text-align: center;
  margin-top: 20px;
  padding-top: 10px;
  font-size: 16px;
  color: #666;
}

/* 确保版权信息文本居中 */
.footer-copyright {
  font-size: 16px;
  margin: 0;
}

// 在style部分添加公网安备文本的样式
.footer-security {
  margin: 5px 0 0 0;
  font-size: 14px;
  color: #666;
}
</style>